import "./ShowSubcategory.css";

import { Breadcrumb, Button, message } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deleteSubcategory, useAppSelector } from "../../../_lib/_store";

export const ShowSubcategoryPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.package);

  const navigate = useNavigate();
  const { state } = useLocation();

  const subcategoryObj = state?.subcategory;

  const handleDelete = async () => {
    const res = await deleteSubcategory(messageApi, subcategoryObj?.id);
    if (res) {
      navigate("/subcategory");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/subcategory">Sub Category</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/category/edit`, {
                  state: { subcategory: state?.subcategory },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Name</p>
            <p className="value">{subcategoryObj?.name}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{subcategoryObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Description</p>
            <p className="value">{subcategoryObj?.description}</p>
          </div>
          <div className="row">
            <p className="label">Package Id</p>
            <p className="value">{subcategoryObj?.package?.name}</p>
          </div>
          <div className="row">
            <p className="label">Category Id</p>
            <p className="value">{subcategoryObj?.category?.name}</p>
          </div>
          <div className="row">
            <p className="label">Parent Id</p>
            <p className="value">{subcategoryObj?.parentId}</p>
          </div>
        </div>
      </div>
    </>
  );
};
